// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1l6v6","info":"UpdateTermsInfo_info__3tWKI"};